import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MainHeaderComponent } from '../../shared/main-header/main-header.component';
import { SchemaRuleDocument, SchemaRulesService } from '../../../services/schema-rules.service';
import { DataTableComponent } from '../../shared/data-table/data-table.component';

@Component({
  selector: 'app-list-schema-rules',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatSnackBarModule,
    MainHeaderComponent,
    DataTableComponent
  ],
  templateUrl: './list-schema-rules.component.html',
  styleUrl: './list-schema-rules.component.scss'
})
export class ListSchemaRulesComponent implements OnInit {
  rules: SchemaRuleDocument[] = [];
  isLoading = true;
  selectedItems: SchemaRuleDocument[] = [];
  columns: any[] = [
    { field: 'id', header: 'ID', filter: true, orderby: true },
    { field: 'rule', header: 'Regla', filter: true, orderby: true },
    { field: 'function_name', header: 'Función', filter: true, orderby: true },
    { field: 'column', header: 'Columna', filter: true, orderby: true },
    { field: 'value', header: 'Valor', filter: true, orderby: true }
  ];

  constructor(
    private schemaRulesService: SchemaRulesService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadRules();
  }

  onCreateRule(): void {
    this.router.navigate(['/schema-rules/create']);
  }

  onEditRule(item: SchemaRuleDocument): void {
    this.router.navigate(['/schema-rules', item.id]);
  }

  onSelectionChange(event: SchemaRuleDocument[]): void {
    this.selectedItems = event ?? [];
  }

  onDeleteRule(item: SchemaRuleDocument): void {
    if (!confirm(`¿Eliminar regla "${item.rule}"?`)) return;

    this.schemaRulesService.deleteRule$(item.id).subscribe({
      next: () => {
        this.snackBar.open('Regla eliminada correctamente.', 'OK', { duration: 3000 });
        this.loadRules();
      },
      error: () => {
        this.snackBar.open('No se pudo eliminar la regla.', 'Cerrar', { duration: 4000 });
      }
    });
  }

  onDeleteFromTable(event: any): void {
    if (!event) return;
    if (Array.isArray(event)) {
      if (!event.length) return;
      const first = event[0] as SchemaRuleDocument;
      this.onDeleteRule(first);
      return;
    }
    this.onDeleteRule(event as SchemaRuleDocument);
  }

  deleteSelectedRules(): void {
    if (!this.selectedItems.length) return;
    if (!confirm('¿Eliminar las reglas seleccionadas?')) return;

    const pending = [...this.selectedItems];
    let remaining = pending.length;

    pending.forEach((item) => {
      this.schemaRulesService.deleteRule$(item.id).subscribe({
        next: () => {
          remaining -= 1;
          if (remaining === 0) {
            this.selectedItems = [];
            this.snackBar.open('Reglas eliminadas correctamente.', 'OK', { duration: 3000 });
            this.loadRules();
          }
        },
        error: () => {
          this.snackBar.open('No se pudieron eliminar todas las reglas.', 'Cerrar', {
            duration: 4000
          });
        }
      });
    });
  }

  private loadRules(): void {
    this.isLoading = true;
    this.schemaRulesService.getRules$().subscribe({
      next: (rules) => {
        this.rules = rules;
        this.isLoading = false;
      },
      error: () => {
        this.rules = [];
        this.isLoading = false;
        this.snackBar.open('No se pudieron cargar las reglas.', 'Cerrar', { duration: 4000 });
      }
    });
  }
}
